import React from 'react';
import { toast, } from "react-toastify"
import Button from '@material-ui/core/Button';
import '../../assets/css/Order.css'
import CustomInput from '../CustomInput/CustomInput';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid'
import Card from "../Card/Card.jsx";
import { NavLink } from "react-router-dom";
import RegularButton from "../../components/CustomButtons/Button.jsx";
import { BASE_URL } from '../../utils/handleApi';
const useStyles = (theme) => ({
  
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(5)
        }
    },
    rootButton: {
        '& > *': {
            margin: theme.spacing(1),
            marginTop: theme.spacing(-1.8),
            marginLeft: theme.spacing(1.5)
        }
    },
    paper: {
        backgroundColor: "red"
    },
    margin: {
        // margin: theme.spacing(1),
        marginRight: theme.spacing(10)
    },
    withoutLabel: {
        marginTop: theme.spacing(2),
    },
    textField: {
        width: '16vw',
    },

});

class Detailstable extends React.Component {
    state = {
        name: "",
        nameState: "",
        productId: "",
        productIdState: "",

        required: "",
        requiredState: "",
        typeEmail: "",
        typeEmailState: "",
        number: "",
        numberState: "",
        url: "",
        urlState: "",
        equalTo: "",
        whichEqualTo: "",
        equalToState: "",

        minLength: "",
        minLengthState: "",
        maxLength: "",
        maxLengthState: "",
        range: "",
        rangeState: "",
        minValue: "",
        minValueState: "",
        maxValue: "",
        maxValueState: "",

        isFormSubmitting: false
    };

  componentDidMount(){
    let { lenderId, productId } = this.props

    let postData = {
      'lender_id': lenderId
    }
    fetch(`${BASE_URL}/product/all`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers:{
        "Content-type": "application/json; charset=UTF-8"
      }
    })
    .then(response => response.json())
    .then((data) => {
      let currentProduct = data.filter((product) => product.id === +productId)[0]
      this.setState({
        name: currentProduct.name,
        nameState: 'success',
        productId: currentProduct.product_id,
        productIdState: 'success',
      })
    })
    
  }

  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  // function that verifies if two strings are equal
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }
  // function that verifies if value contains only numbers
  verifyNumber(value) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }
  // verifies if value is a valid URL
  verifyUrl(value) {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  }
  change(event, stateName, type, stateNameEqualTo, maxValue) {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "equalTo":
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "checkbox":
        if (event.target.checked) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "number":
        if (this.verifyNumber(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-length":
        if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "url":
        if (this.verifyUrl(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "min-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value <= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "range":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo &&
          event.target.value <= maxValue
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
    switch (type) {
      case "checkbox":
        this.setState({ [stateName]: event.target.checked });
        break;
      default:
        this.setState({ [stateName]: event.target.value });
        break;
    }
  }

  updateProduct = () => {
    const { lenderId, productId } = this.props
    const { name } = this.state;
    let isValid = true;

    if (name.trim() === "") {
      this.setState({ nameState: "error" });
      isValid = false
    }

    if(isValid){
      this.setState({ isFormSubmitting: true })
      let tokenStr = localStorage.getItem('admin_token');
      let dict = JSON.stringify({
        "lender_id": lenderId,
        "product_id": this.state.productId,
        "name": name,
      })

      fetch(`${BASE_URL}/product/update?product_id=${productId}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenStr}`
        },
        body: dict
      })
      .then(() => {
        toast.success('Product Updated Successfully!', {
          onClose: () => window.history.back()
        })
      })
      .catch(() => {
        toast.error('Some error happened!', {
          onClose: () => this.setState({ isFormSubmitting: false })
        })
      })
    }
  }
    
      
    render() {
        const { classes } = this.props
        const { productIdState, productId, nameState, name, isFormSubmitting } = this.state;
        return (
          <Grid container className="form-container" style={{ width: '60vw', margin: '0 auto', backgroundColor: 'white' }}>
                    <Grid item xs={12}>
                      <div style={{width:'95%'}}>
                        <Card style={{ boxShadow: '0px 0px 5px 0px #d6d6d6'  }}>
                            <div className={classes.rootButton}>
                                <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                  Edit Product
                                </Button>
                                {/* <NavLink to={ `/MyLenders/products/${this.props.lenderId}`}>  */}
                                <NavLink to={{ 
                                    pathname: `/MyLenders/products/${this.props.lenderId}`, 
                                    state: {
                                        lender_name: this.props.lenderName
                                    }
                                }}>
                                  <div className={classes.rootButton} style={{float: "right"}}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', 
                                    color: 'white', height: '50px', width: '120px', fontFamily: 'Roboto-Bold', 
                                    backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '10px' }} 
                                      >
                                        Back
                                    </Button>
                                  </div>
                                </NavLink>
                            </div>
                            <CardContent>          
                              <form className="productform">
                               <CustomInput
                                success={productIdState === "success"}
                                error={productIdState === "error"}
                                labelText="Product ID *"
                                id="productId"
                                formControlProps={{
                                    fullWidth: true,
                                    style: {borderBottom: '1px solid #04ab23'}
                                }}
                                inputProps={{
                                    // onChange: event =>
                                    // this.change(event, "productId", "length", 1),
                                    type: "number",
                                    value: productId,
                                    readOnly: true,
                                    disabled: true,
                                }}/> 
                              <CustomInput
                              success={nameState === "success"}
                              error={nameState === "error"}
                              labelText="Name *"
                              id="name"
                              formControlProps={{
                                  fullWidth: true
                              }}
                              inputProps={{
                                  onChange: event =>
                                    this.change(event, "name", "length", 0),
                                  type: "text",
                                  value: name
                              }}
                              />
                              </form>
                            </CardContent>
                            <div className={classes.rootButton} style={{textAlign: 'center'}}>
                              <RegularButton variant="contained"
                               disabled={isFormSubmitting} 
                              style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '190px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center' }} 
                              onClick = {this.updateProduct}>
                                Update Product
                              </RegularButton>
                            </div>
                      </Card>    
                    </div>
                  </Grid>
                </Grid>
        )
    }
}
export default withStyles(useStyles, { withTheme: true })(Detailstable)